import { extractSharingResource } from 'src/app/pages/starterDashboardV2/shared/contexts';
import type {
	PlatformDataMap,
	StarterDashboardV2ShareRecommendationsQuery,
} from 'src/app/pages/starterDashboardV2/shared/hooks';

import { EXECUTORS } from '../hooks/actions/executors';
import type { ActionsReturnType } from '../hooks/actions/types';
import { rtsForFullPostType } from '../utils/readyToShareMapper';

import type { FullPostType, SharingModalFactoryProps } from './types';

type RecommendedGroup = StarterDashboardV2ShareRecommendationsQuery['shareRecommendations'][
	| 'facebook'
	| 'reddit'][number];

export function useActionsFactory(props: SharingModalFactoryProps, dynamicData: PlatformDataMap): ActionsReturnType {
	let recommendedGroup: RecommendedGroup | undefined;
	const { platform, postType, petition } = props;

	if ('recommendedGroup' in props) {
		recommendedGroup = props.recommendedGroup as RecommendedGroup;
	}

	const fullPostType = `${platform}${recommendedGroup ? '_group' : ''}_${postType}` as FullPostType;
	const readyToSharePost = rtsForFullPostType(fullPostType, dynamicData);

	const sharingResource = extractSharingResource(fullPostType, {
		post: readyToSharePost,
		petition,
		recommendedGroup,
	});

	// Add sharingResource to props for executors
	const propsWithSharingResource = {
		...props,
		sharingResource: {
			message: sharingResource.message,
			previewImageUrl: sharingResource.previewImageUrl,
			shareUrl: sharingResource.shareUrl,
		},
	};

	return EXECUTORS[fullPostType](propsWithSharingResource);
}
